import { render, staticRenderFns } from "./KaijuPayoutItem.vue?vue&type=template&id=11228e2d&"
import script from "./KaijuPayoutItem.vue?vue&type=script&lang=ts&"
export * from "./KaijuPayoutItem.vue?vue&type=script&lang=ts&"
import style0 from "./KaijuPayoutItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports